import { lazy } from 'react';
import { FileText, ShieldCheck, Upload, Landmark, Users, UserCheck, Palette, Mail, Building2 } from 'lucide-react';

// Sub-flujos pesados → lazy para no inflar el bundle del Home.
const OnboardingFiscalStep = lazy(() => import('./OnboardingFiscalStep'));
const InviteManager = lazy(() => import('@/pages/InviteManager'));
const MiZonaLinkGuide = lazy(() => import('./MiZonaLinkGuide'));
const OnboardingEmailInStep = lazy(() => import('./OnboardingEmailInStep'));
const OnboardingInmueblesStep = lazy(() => import('./OnboardingInmueblesStep'));

// Configuración de los pasos de onboarding, fuente única compartida entre el
// checklist "Primeros pasos" (PrimerosPasos.jsx) y el asistente guiado
// (SetupWizard.jsx). `mode: 'modal'` embebe el componente existente en un Dialog;
// `mode: 'navigate'` lleva a la página dedicada (flujos pesados: conexión bancaria
// PSD2 y branding con subida de logo).
//
// `tier` tiene 3 valores:
//   'essential'   — bloquea el resto de la app (`OnboardingGate.jsx`) hasta
//                   completarse. Solo la identidad fiscal: sin CIF no se puede
//                   emitir una factura válida, y eso es lo único de lo que no
//                   se puede prescindir.
//   'recommended' — alto valor pero no bloqueante. Siempre visible.
//   'optional'    — baja prioridad. Colapsado por defecto en el checklist para
//                   no abrumar con tarjetas que la mayoría no necesita de
//                   entrada.
//
// Lo que NO está aquí y antes sí: el plan de cuentas y las series de
// facturación. Se siembran solos al crear la empresa y se auto-reparan después
// (ver `verix-api/src/functions/onboarding/onboardingStatus.ts`), así que
// pedirle al usuario que los "haga" era pedirle marcar una casilla ya marcada.
// `InvoiceSeriesManager` y `PgcSyncButton` siguen vivos en Configuración, que es
// donde tiene sentido personalizarlos o repararlos.
export const STEPS = [
  { key: 'fiscal',      icon: FileText,    mode: 'modal',    Component: OnboardingFiscalStep, tier: 'essential' },
  { key: 'fiscal_cert', icon: ShieldCheck, mode: 'navigate', to: '/configuracion-fiscal', tier: 'recommended' },
  { key: 'data_import', icon: Upload,      mode: 'navigate', to: '/datos', tier: 'recommended' },
  { key: 'bank',        icon: Landmark,    mode: 'navigate', to: '/bancos', tier: 'recommended' },
  { key: 'users',       icon: Users,       mode: 'modal',    Component: InviteManager, tier: 'optional' },
  { key: 'mizona',      icon: UserCheck,   mode: 'modal',    Component: MiZonaLinkGuide, tier: 'optional' },
  { key: 'branding',    icon: Palette,     mode: 'navigate', to: '/configuracion?section=branding', tier: 'optional' },
  { key: 'email_in',    icon: Mail,        mode: 'modal',    Component: OnboardingEmailInStep, ackOnClose: false, tier: 'optional' },
  // #2115 — inmuebles arrendados con retención (Modelo 180). `recommended` y no
  // `optional`: la referencia catastral la tiene el CLIENTE y tarda días en llegar,
  // así que un paso plegado por defecto se ve en enero, que es tarde. Un tenant que
  // no alquile nada lo cierra en un clic ("No, no alquilo ningún inmueble") y deja
  // esa respuesta escrita — que no es lo mismo que no haber contestado.
  { key: 'inmuebles',   icon: Building2,   mode: 'modal',    Component: OnboardingInmueblesStep, ackOnClose: false, tier: 'recommended' },
];

export const ESSENTIAL_STEP_KEYS = STEPS.filter((s) => s.tier === 'essential').map((s) => s.key);
